// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.series-complete-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.results-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  width: 100%;
}

.result-header {
  position: relative;
  padding: 40px 20px;
  text-align: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  overflow: hidden;
}

.result-header.win {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.result-header.loss {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.result-header.tie {
  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
}

.result-header h1 {
  margin: 0;
  font-size: 24px;
  position: relative;
  z-index: 1;
}

.result-badge {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.result-message {
  padding: 20px;
  text-align: center;
  background: #f9f9f9;
}

.result-message h2 {
  margin: 0;
  color: #333;
  font-size: 20px;
}

.series-stats {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 15px;
  padding: 30px 20px;
  background: white;
}

.stat-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stat-box.player-stat,
.stat-box.opponent-stat {
  background: #f9f9f9;
  padding: 20px;
  border-radius: 8px;
}

.stat-name {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-number {
  font-size: 40px;
  font-weight: 700;
  color: #667eea;
  line-height: 1;
  margin-bottom: 8px;
}

.stat-number.wins {
  color: #27ae60;
}

.stat-label {
  font-size: 12px;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.financial-summary {
  background: #f9f9f9;
  padding: 20px;
  margin: 20px;
  border-radius: 8px;
  border-left: 4px solid #667eea;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.summary-row:last-child {
  margin-bottom: 0;
}

.summary-row span {
  color: #666;
}

.summary-row strong {
  color: #333;
  font-weight: 600;
}

.summary-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 10px 0;
}

.summary-row.profit-loss {
  padding-top: 10px;
  font-size: 16px;
  font-weight: 600;
}

.summary-row.profit-loss.gain strong {
  color: #27ae60;
}

.summary-row.profit-loss.loss strong {
  color: #e74c3c;
}

.summary-row.profit-loss.neutral strong {
  color: #f39c12;
}

.games-breakdown {
  padding: 20px;
  background: white;
}

.games-breakdown h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.games-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.game-result {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f9f9f9;
  border-radius: 8px;
  border-left: 4px solid #ddd;
}

.game-result.completed {
  border-left-color: #667eea;
}

.game-result.tie {
  border-left-color: #f39c12;
}

.game-number {
  font-size: 14px;
  font-weight: 600;
  color: #666;
}

.game-outcome span {
  font-size: 14px;
  font-weight: 600;
}

.game-outcome .winner {
  color: #27ae60;
}

.game-outcome .loser {
  color: #e74c3c;
}

.game-outcome .tie {
  color: #f39c12;
}

.actions {
  padding: 20px;
  display: flex;
  gap: 10px;
  background: #f9f9f9;
  border-top: 1px solid #eee;
}

.btn-home {
  flex: 1 1;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-home:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.3);
}

.btn-home:active {
  transform: translateY(0);
}

.error-message {
  text-align: center;
  padding: 40px 20px;
  color: #e74c3c;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/SeriesComplete.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".series-complete-container {\n  max-width: 600px;\n  margin: 0 auto;\n  padding: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n}\n\n.results-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  overflow: hidden;\n  width: 100%;\n}\n\n.result-header {\n  position: relative;\n  padding: 40px 20px;\n  text-align: center;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  overflow: hidden;\n}\n\n.result-header.win {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.result-header.loss {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n}\n\n.result-header.tie {\n  background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);\n}\n\n.result-header h1 {\n  margin: 0;\n  font-size: 24px;\n  position: relative;\n  z-index: 1;\n}\n\n.result-badge {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 700;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.result-message {\n  padding: 20px;\n  text-align: center;\n  background: #f9f9f9;\n}\n\n.result-message h2 {\n  margin: 0;\n  color: #333;\n  font-size: 20px;\n}\n\n.series-stats {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 15px;\n  padding: 30px 20px;\n  background: white;\n}\n\n.stat-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.stat-box.player-stat,\n.stat-box.opponent-stat {\n  background: #f9f9f9;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n.stat-name {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.stat-number {\n  font-size: 40px;\n  font-weight: 700;\n  color: #667eea;\n  line-height: 1;\n  margin-bottom: 8px;\n}\n\n.stat-number.wins {\n  color: #27ae60;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.financial-summary {\n  background: #f9f9f9;\n  padding: 20px;\n  margin: 20px;\n  border-radius: 8px;\n  border-left: 4px solid #667eea;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.summary-row:last-child {\n  margin-bottom: 0;\n}\n\n.summary-row span {\n  color: #666;\n}\n\n.summary-row strong {\n  color: #333;\n  font-weight: 600;\n}\n\n.summary-divider {\n  height: 1px;\n  background: #e0e0e0;\n  margin: 10px 0;\n}\n\n.summary-row.profit-loss {\n  padding-top: 10px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.summary-row.profit-loss.gain strong {\n  color: #27ae60;\n}\n\n.summary-row.profit-loss.loss strong {\n  color: #e74c3c;\n}\n\n.summary-row.profit-loss.neutral strong {\n  color: #f39c12;\n}\n\n.games-breakdown {\n  padding: 20px;\n  background: white;\n}\n\n.games-breakdown h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.games-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.game-result {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px;\n  background: #f9f9f9;\n  border-radius: 8px;\n  border-left: 4px solid #ddd;\n}\n\n.game-result.completed {\n  border-left-color: #667eea;\n}\n\n.game-result.tie {\n  border-left-color: #f39c12;\n}\n\n.game-number {\n  font-size: 14px;\n  font-weight: 600;\n  color: #666;\n}\n\n.game-outcome span {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.game-outcome .winner {\n  color: #27ae60;\n}\n\n.game-outcome .loser {\n  color: #e74c3c;\n}\n\n.game-outcome .tie {\n  color: #f39c12;\n}\n\n.actions {\n  padding: 20px;\n  display: flex;\n  gap: 10px;\n  background: #f9f9f9;\n  border-top: 1px solid #eee;\n}\n\n.btn-home {\n  flex: 1;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-home:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-home:active {\n  transform: translateY(0);\n}\n\n.error-message {\n  text-align: center;\n  padding: 40px 20px;\n  color: #e74c3c;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
